class Services {
    static async requestOTP(userID){
        // const authToken = "uVeRihmMSuaIV8hIkuTd6YrW842iqtUp";
        
        const response = await fetch(`${environmentURLs.BaseEligibilityURL}v1/media-portal/${userID}/pension-reform-eligibility`,{
          method: 'GET',
          headers: {
            'x-apikey': environmentURLs.authToken,
            'userId': userID,
          },
        });
      
        return response;
    }

    static async submitOTP(userID,encUID,otp){
        // const authToken = "uVeRihmMSuaIV8hIkuTd6YrW842iqtUp";
        
        const response = await fetch(`${environmentURLs.BaseEligibilityURL}v1/media-portal/${userID}/pension-reform-eligibility`,{
          method: 'GET',
          headers: {
            'x-apikey': environmentURLs.authToken,
            'userId': userID,
            'x-otp': `${encUID}:${otp}`
          },
        }); 
      
        return response;
    }

}

export { Services };
